module.exports = __webpack_public_path__ + "static/berrettini-gray-ed04e2cc7581dae6c218ff84f3728a9b.png";